module.exports = {
      id: "line-arrow-next-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#line-arrow-next",
      toString: function () {
        return this.url;
      }
    }